import React, { FC } from 'react';
import styled from '@emotion/styled';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { BlueprintChange, formatBlueprintValue } from '../blueprintStorage';
import useBlueprintValueLabels from './useBlueprintValueLabels';

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

/** Level 5 is 12px; Handy goes one step below that. Shared so rows don't allocate a style object each */
const HANDY_TEXT_STYLE = { fontSize: 11 } as const;

interface Props {
  change: BlueprintChange;
  color: string;
  /** Smaller text on handheld screens */
  isHandy?: boolean;
}

/** One changed setting: key on the left, "current → new" on the right */
const ChangeRow: FC<Props> = ({ change, color, isHandy = false }) => {
  const labels = useBlueprintValueLabels();
  const textStyle = isHandy ? HANDY_TEXT_STYLE : undefined;

  return (
    <Row>
      <Paragraph level={5} color={color} style={textStyle}>
        {change.key}
      </Paragraph>
      <Paragraph level={5} color={color} style={textStyle}>
        {formatBlueprintValue(change.from, labels)} → {formatBlueprintValue(change.to, labels)}
      </Paragraph>
    </Row>
  );
};

export default ChangeRow;
